function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  id: "Oval",
  cx: 11.5,
  cy: 11.5,
  r: 11.5,
  fill: "#ec6423"
});

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "error",
  transform: "translate(7 7)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path",
  d: "M8.666,7.312,5.827,4.473,8.666,1.634A.957.957,0,1,0,7.312.28L4.473,3.119,1.634.28A.957.957,0,1,0,.28,1.634L3.119,4.473.28,7.312A.957.957,0,1,0,1.634,8.666L4.473,5.827,7.312,8.666A.957.957,0,1,0,8.666,7.312Z",
  transform: "translate(0.027 0.027)",
  fill: "#fff"
}));

function SvgMajor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMajor);
export default __webpack_public_path__ + "static/media/major.67ad6e93.svg";
export { ForwardRef as ReactComponent };